/**Import react section */
import React, { useState } from 'react'
import propTypes from 'prop-types'
import withImmutablePropsToJS from 'with-immutable-props-to-js'

/**Import material section */
import { Card, CardHeader, Grid, Paper, Typography } from '@material-ui/core'

/**Import components section */
import { Content, Header, HeaderBreadCrum, Layout } from '../layouts/AuthenticatedLayout'
import SideBar from '../common/DashboadSideBar'
import iconSparePart from '../../resources/images/sparePart.svg'
import ToolbarComponent from '../common/Toolbar'
import AlertComponent from '../common/AlertComponent'
import ConfirmDeleteDialog from './Visualizer/ConfirmDeleteDialog'
import ButtonSaved from '../common/Buttons/ButtonSaved'
import TextBox from '../common/TextBox'
import ImagesNoInformation from '../common/ImagesNoInformation'
import ImageVisualizer from './Visualizer/ImageVisualizer'
import ButtonCancel from '../common/Buttons/ButtonCancel'

/**Import helpers section */
import { PORTAL_ADMINISTRATOR, SPARE_PARTS_IMBERA_USA } from '../../resources/RolesEnum'
import { hasAuthorization } from '../../store/session/sessionActions'

/**Import styles section */
import { SparePartImagesDesktopStyles } from './SparePartImagesDesktopStyles'
import ImgThumbnailAdderComponent from './Visualizer/ImgThumbnailAdderComponent'

const SparePartImagesDesktopView = (props) => {
	/**objects props sections */
	const { userProfile, sparePartImage, confirmDialog, imagesByCodeSearch } = props
	/**functions props sections */
	const { deleteImage, handleOpenConfirmDialog, handleCloseConfirmDialog, onSearchSerie, addImage, onDownloadSparePartImagesReport } = props
	/**bool props sections */
	const { isDeletingImage, isGetingImageContainer, isUploadingImage } = props
	/**string props sections */
	const { serieFromPath } = props

	let isAuthorizadoForAddImage = hasAuthorization(userProfile, [SPARE_PARTS_IMBERA_USA, PORTAL_ADMINISTRATOR])

	const classes = SparePartImagesDesktopStyles()
	const [codeSerach, setCodeSerach] = useState()
	const [deleteMode, setDeleteMode] = useState(false)

	return (
		<Layout>
			<Header
				key={'AuthenticatedHeader'}
				user={props.user}
				breadcrumbs={
					<HeaderBreadCrum>
						<Typography color='secondary'>Serial history</Typography>
					</HeaderBreadCrum>
				}
			/>
			<SideBar key={'AuthenticatedSideBar'} onChangeLocation={props.onChangeLocation} selectedButtonIndex={12} userProfile={userProfile} />
			<Content key={'AuthenticatedContent'}>
				<div className={classes.root}>
					{(!serieFromPath || isGetingImageContainer) && (
						<>
							<ToolbarComponent title='SEARCH SERIAL SAP IMAGES' icon={iconSparePart} />
							<Paper className={classes.paperSearch}>
								<Typography variant='subtitle2'>Search the Spare Part code</Typography>
								<Grid container spacing={1} alignItems='center'>
									<Grid item xs={8} style={{ display: 'flex', alignItems: 'center' }}>
										<TextBox
											disabled={isGetingImageContainer}
											onChange={(event) => setCodeSerach(event.target.value)}
											value={codeSerach}
											active={true}
											fullWidth
											autoFocus
											name='codeSerach'
											variant='outlined'
											margin='dense'
											label='Spare Part code'
											type={'number'}
										/>
									</Grid>
									<Grid item xs={1}>
										{/* <Grid item xs={2} style={{ marginTop: '0.5rem' }}> */}
										<ButtonSaved
											title='Search'
											isSaving={isGetingImageContainer || !codeSerach}
											onSavedClick={() => onSearchSerie(codeSerach)}
										/>
									</Grid>
									<Grid item xs={3} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
										{/* <Grid item xs={2} style={{ marginTop: '0.5rem' }}> */}

										{isAuthorizadoForAddImage && (
											<ImgThumbnailAdderComponent
												isLoading={isUploadingImage}
												onAddEvidence={(evidences) => addImage(evidences)}
											/>
										)}

										<ButtonSaved
											title='Download report'
											isSaving={isUploadingImage}
											onSavedClick={onDownloadSparePartImagesReport}
										/>
										{isAuthorizadoForAddImage && imagesByCodeSearch.length > 0 && (
											<ButtonCancel title={'Delete mode'} onCancelClick={() => setDeleteMode(!deleteMode)} />
										)}
									</Grid>
								</Grid>
								<div className={classes.imagesSection}>
									<ImageVisualizer
										images={imagesByCodeSearch}
										canBeDelete={deleteMode}
										onDeleteEvidence={handleOpenConfirmDialog}
										isLoadingDeleteImages={isDeletingImage}
									/>
								</div>
								<ImagesNoInformation
									data={imagesByCodeSearch}
									isLoading={isGetingImageContainer}
									titleData={'There are no search results, please upload or search by code.'}
								/>
							</Paper>
						</>
					)}

					{sparePartImage && !isGetingImageContainer && serieFromPath && (
						<>
							<ToolbarComponent title='SEARCH SERIE FROM SAP' icon={iconSparePart} />
							<Card>
								<CardHeader
									title={<Typography className={classes.textExpanded}> {` SPARE PARTS`} </Typography>}
									subheader={
										<div>
											<Typography>
												<strong>{`Serie: `}</strong>
												{` ${sparePartImage?.Serie} `} | <strong>{`Model: `}</strong> {` ${sparePartImage?.Model} `}
											</Typography>
											<Typography>
												<strong>{`Description: `}</strong>{' '}
												{` ${sparePartImage?.MaterialCode} | ${sparePartImage?.MaterialDescription} `}{' '}
											</Typography>
											<Typography>
												<strong>{`Customer: `}</strong>{' '}
												{` ${sparePartImage?.CustomerCode} | ${sparePartImage?.CustomerName} `}{' '}
											</Typography>
											<Typography>
												<strong>{`Destination: `}</strong>{' '}
												{` ${sparePartImage?.DestinationCode} | ${sparePartImage?.DestinationName} `}{' '}
											</Typography>
										</div>
									}
								/>
							</Card>
							<Paper className={classes.paperSearch}>
								<Grid container spacing={1}>
									<Grid item xs={12}>
										<AlertComponent
											title={`Code: ${sparePartImage?.Code} Description: ${sparePartImage?.Description}`}
											severityType='info'
											message='Note: the image is for reference only.'
										/>
									</Grid>
								</Grid>
								<br />
								{sparePartImage?.Attachments?.length > 0 ? (
									<div className={classes.imagesSection}>
										<ImageVisualizer images={sparePartImage?.Attachments} />
									</div>
								) : (
									<ImagesNoInformation
										data={imagesByCodeSearch}
										isLoading={isGetingImageContainer}
										titleData={'There are no image results'}
									/>
								)}
							</Paper>
						</>
					)}

					<ConfirmDeleteDialog
						open={confirmDialog.open}
						url={confirmDialog.imageName}
						onClose={() => handleCloseConfirmDialog()}
						onHandleConfirm={() => deleteImage(codeSerach, confirmDialog.imageName)}
						isDeletingImage={isDeletingImage}
					/>
				</div>
			</Content>
		</Layout>
	)
}
SparePartImagesDesktopView.propTypes = {
	/**Determinate user logged */
	userProfile: propTypes.object.isRequired,
	onChangeLocation: propTypes.func.isRequired,
	addImage: propTypes.func.isRequired,
	deleteImage: propTypes.func.isRequired
}
SparePartImagesDesktopView.defaultProps = {
	userProfile: {},
	onChangeLocation: () => 'prop function [onChangeLocation] is not defined',
	addImage: () => 'prop function [addImage] is not defined',
	deleteImage: () => 'prop function [deleteImage] is not defined'
}

export default withImmutablePropsToJS(SparePartImagesDesktopView)
